import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function LettersView() {
  const navigate = useNavigate();
  const [letters, setLetters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [customerData, setCustomerData] = useState(null);

  useEffect(() => {
    const fetchLetters = async () => {
      try {
        const customerStr = localStorage.getItem('customer');
        if (!customerStr) {
          setError('Not authenticated');
          setLoading(false);
          return;
        }

        const customer = JSON.parse(customerStr);
        setCustomerData(customer);

        const response = await fetch(
          `${BACKEND_URL}/api/customer/${customer.id}/letters`
        );

        if (!response.ok) {
          throw new Error('Failed to fetch letters');
        }

        const data = await response.json();
        setLetters(data.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLetters();
  }, []);

  const handleViewLetter = (letterId) => {
    navigate(`/letter/${customerData.id}/${letterId}`);
  };

  const handleDownloadPDF = async (letterId) => {
    try {
      const response = await fetch(
        `${BACKEND_URL}/api/customer/${customerData.id}/letter/${letterId}/pdf`
      );

      if (!response.ok) {
        throw new Error('Failed to download PDF');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${letterId}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Error downloading PDF: ' + err.message);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
        <p>Loading letters...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#dc2626' }}>
        <p>❌ {error}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      <h1 style={{ color: '#1b7abf', marginBottom: '10px' }}>📄 Company Letters</h1>
      <p style={{ color: '#666', marginBottom: '30px' }}>
        View and download official letters from AAA Irrigation Service
      </p>

      {letters.length === 0 ? (
        <div
          style={{
            backgroundColor: '#f0fdf4',
            border: '1px solid #dcfce7',
            borderRadius: '8px',
            padding: '30px',
            textAlign: 'center',
            color: '#166534'
          }}
        >
          <p style={{ fontSize: '16px', margin: 0 }}>✓ No letters at this time</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '16px' }}>
          {letters.map((letter) => (
            <div
              key={letter.name}
              style={{
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '16px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                transition: 'box-shadow 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)'}
              onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)'}
            >
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 5px 0', color: '#1a202c', fontSize: '16px' }}>
                  {letter.title}
                </h3>
                <div style={{ color: '#666', fontSize: '14px' }}>
                  {letter.letter_date && (
                    <p style={{ margin: '3px 0' }}>
                      📅 {new Date(letter.letter_date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </p>
                  )}
                  {letter.recipient_name && (
                    <p style={{ margin: '3px 0' }}>
                      👤 {letter.recipient_name}
                    </p>
                  )}
                </div>
              </div>
              <div style={{ display: 'flex', gap: '10px', marginLeft: '20px' }}>
                <button
                  onClick={() => handleViewLetter(letter.name)}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#1b7abf',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  View
                </button>
                <button
                  onClick={() => handleDownloadPDF(letter.name)}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#ea580c',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  📥 PDF
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
